const adminURL = process.env.VUE_APP_ADMIN_API || '';

function resolveBaseApiURL() {
  if (adminURL) {
    return adminURL.replace(/\/admin\/?$/, '');
  }
  if (process.env.VUE_APP_ROOT_API) {
    return process.env.VUE_APP_ROOT_API;
  }
  if (typeof window !== 'undefined' && window.location && window.location.origin) {
    return `${window.location.origin}/api`;
  }
  return '';
}

export const server = {
  adminURL,
  baseApiURL: resolveBaseApiURL(),
  baseURL: process.env.VUE_APP_SERVER_ROOT,
};
